import Typed from 'typed.js';

export function mainBanner() {
  const parent = document.querySelector('.main-banner');
  if (!parent) return;

  const beginningTemplateElement = parent.querySelector('.main-banner__beginning-template');
  const beginningTypingElement = parent.querySelector('.main-banner__beginning-typing');
  const endingsTemplateElement = parent.querySelector('.main-banner__endings-template');
  const endingsTypingElement = parent.querySelector('.main-banner__endings-typing');
  const backgrounds = parent.querySelectorAll('.main-banner__bg');

  backgrounds.forEach((bg, idx) => {
    if (idx !== 0) bg.hidden = true;
  });

  const startAnimation = () => {
    new Typed(endingsTypingElement, {
      stringsElement: endingsTemplateElement,
      typeSpeed: 50,
      startDelay: 0,
      backSpeed: 40,
      backDelay: 2300,
      smartBackspace: true,
      loop: true,
      showCursor: true,
      cursorChar: '|',
      cursorBlinking: false,
      autoInsertCss: true,

      preStringTyped: (arrayPos, self) => {
        backgrounds.forEach((bg, idx) => {
          if (idx === arrayPos) bg.hidden = false;
          else bg.hidden = true;
        });
      },
    });
  };

  const beginningTyped = new Typed(beginningTypingElement, {
    stringsElement: beginningTemplateElement,
    typeSpeed: 30,
    smartBackspace: true,
    showCursor: true,
    cursorChar: '|',
    cursorBlinking: false,
    autoInsertCss: true,
    onComplete: () => {
      beginningTyped.cursorBlinking = false;
      beginningTyped.cursor.remove();
      startAnimation();
    },
  });
}
